import { PALETTE_COLOR_ROLES } from './GlobalStylesConstants.js';
import { printTheme } from './GlobalStylesUtils.js';

const lightTheme = `
  ${printTheme('light', PALETTE_COLOR_ROLES)}
  --spz-sys-color-panel: rgba(225, 225, 225, 0.7);
  --spz-sys-filter-panel: blur(30px);
`;
const darkTheme = `
  ${printTheme('dark', PALETTE_COLOR_ROLES)}
  --spz-sys-color-panel: rgba(40, 40, 40, 0.7);
  --spz-sys-filter-panel: blur(30px);
`;

export const GlobalStylesThemes = `
  :root {
    @media (prefers-color-scheme: light) {
      ${lightTheme}
    }
    @media (prefers-color-scheme: dark) {
      ${darkTheme}
    }
  }
  :root.light {
    ${lightTheme}
  }
  :root.dark {
    ${darkTheme}
  }
`;
